import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-tile',
    standalone: true,
    imports: [MatCardModule],
    template: `
    <mat-card>
      <mat-card-title>{{ title }}</mat-card-title>
      <div class="count">
        {{ count }}
      </div>
    </mat-card>
  `,
    styleUrl: './tile.component.scss'

})
export class TileComponent {
    @Input({required: true}) title!: string;
    @Input({required: true}) count!: number;
}
